import React, { useCallback } from 'react';
import cx from 'classnames';

import {
  SettingsManager,
  SiteConfigManager,
  useApplicationState,
  useBetslipState,
  useBetslipStateUpdate,
  useSettings,
} from '@atlas/core';
import { Icon, Label, ToggleCheckbox } from '@atlas/ui';

import { CANNOT_TURN_OFF_QUICK_BET_ERROR } from 'common/Betslip/constants';
import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';

const IframeBetslipSwitchers = ({ setVisibleBetslipSettings }) => {
  const { authenticated, resolved } = useApplicationState();

  const { betItems, loading, settings } = useBetslipState();

  const { quickBet: isQuickBet } = useSettings();

  const { isOrderBet, setIsOrderBet } = useLocalBetslip();

  const betslipStateUpdate = useBetslipStateUpdate();

  const handleToggleQuickBet = useCallback(() => {
    if (loading) {
      return betslipStateUpdate({ errors: CANNOT_TURN_OFF_QUICK_BET_ERROR });
    }
    SettingsManager.updateSettings({ quickBet: !isQuickBet });
  }, [betslipStateUpdate, isQuickBet, loading]);

  const handleToggleOrderBet = useCallback(() => {
    setIsOrderBet(!isOrderBet);
  }, [isOrderBet, setIsOrderBet]);

  const toggleQuickBetClass = cx('toggle-container', { active: isQuickBet });
  const toggleOrderBetClass = cx('toggle-container', { active: isOrderBet });

  // Checking all rules for order bet switch
  const isOrderBetAllowed =
    resolved && authenticated && !isQuickBet && !!settings.orderBet && betItems.length > 0;

  const enableOddsSettings = SiteConfigManager.getConfig(
    'config.config.betslip.enableOddsSettings',
  );

  return (
    <>
      <div className="quick-bet-container quick-bet-container_iframe">
        <div className="betslip-switcher">
          <div className={toggleQuickBetClass}>
            <ToggleCheckbox
              checked={isQuickBet}
              disabled={loading || isOrderBet}
              id="betslip-quick-bet"
              label="turn_quick_bet_on"
              onChange={handleToggleQuickBet}
            />
          </div>
        </div>

        {enableOddsSettings && (
          <div className="betslip-switcher">
            <button
              className="betslip-switchers-btn"
              onClick={() => setVisibleBetslipSettings(true)}
              type="button"
            >
              <Icon className="betslip-switchers-btn__icon" name="settings" />
              <Label
                className="betslip-switchers-btn__label"
                message="betslip_sportsbook_settings"
              />
            </button>
          </div>
        )}
      </div>

      {isOrderBetAllowed && (
        <div className="quick-bet-container quick-bet-container_iframe">
          <div className={toggleOrderBetClass}>
            <ToggleCheckbox
              checked={isOrderBet}
              disabled={loading}
              id="betslip-order-bet"
              label="turn_order_bet_on"
              onChange={handleToggleOrderBet}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default IframeBetslipSwitchers;
